// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AkcuaGUFTDEI_w {
  text-align: center;
}
.FryW1VnMZUdyIq {
  height: 120px;
  margin-right: auto;
  margin-bottom: var(--ds-space-300, 24px);
  margin-left: auto;
}
.VItSznQ6Oxez1H {
  display: flex;
  align-items: center;
  justify-content: center;
}
.GFKZ4vt0d3cNvJ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `AkcuaGUFTDEI_w`,
	"headerImage": `FryW1VnMZUdyIq`,
	"description": `VItSznQ6Oxez1H`,
	"loading": `GFKZ4vt0d3cNvJ`
};
export default ___CSS_LOADER_EXPORT___;
